<template>
  <div class="event-child">
    <h2 class="event-subtitle">Регистрация</h2>

    <h3 v-if="registered" style="text-align: center;">Вашата регистрация беше приета успешно.</h3>

    <h3 v-else-if="invalidOrRegistered" style="text-align: center;">Вече сте регистрирани или линкът за потвърждаване е изтекъл.</h3>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

export default {
  name: 'ElectionRegistrationConfirm',

  data () {
    return {
      registered: false,
      invalidOrRegistered: false
    }
  },

  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('confirmElectionRegistration', this.$route.params.token).then(response => {
      this.$store.commit('setLoading', false)
      this.registered = true

      // if the server returned a JWT (aka. the user is not logged in),
      // try to log the user in
      if (response.data && response.data.token) {
        try {
          const decodedToken = jwtDecode(response.data.token)
          if (decodedToken.exp && (decodedToken.exp * 1000) > Date.now()) {
            // successful login
            this.$store.commit('setAuthToken', response.data.token)

            // get user
            this.$store.dispatch('getUser', decodedToken.data.user.id)
          }
        } catch (e) {
          // commit('setAuthToken', null)
          // localStorage.removeItem('authToken')
          // localStorage.removeItem('user')
        }
      }
    }).catch(() => {
      this.$store.commit('setLoading', false)
      this.invalidOrRegistered = true
    })
  }
}
</script>
